import styled, { css } from 'styled-components';
import { flexCenter } from 'common-package/src/styles/utils';

const pcStyle = css`
  width: 100%;
  height: 600px;
  margin: 0 auto;
  ${flexCenter('column')}

  img {
    width: 88px;
    height: 88px;
  }

  .title {
    margin: 37px 0 13px;
    font-size: 24px;
    font-weight: 600;
    color: #333;
    line-height: 32px;
  }

  .desc {
    font-size: 16px;
    color: #666;
    line-height: 24px;
    margin: 0px;
    text-align: center;

    strong {
      color: var(--primary-color);
    }
  }

  .success-btn {
    width: 220px;
    height: 48px;
    font-size: var(--font-size-lg);
  }
`;

const mobileStyle = css`
  width: 100%;
  height: 712px;
  margin: 0 auto;
  ${flexCenter('column')}

  img {
    width: 136px;
    height: 136px;
  }

  .title {
    margin: 54px 0 20px;
    font-size: 32px;
    font-weight: 600;
    color: var(--text-color-0);
    line-height: 40px;
  }

  .desc {
    font-size: 24px;
    color: var(--text-color-1);
    line-height: 34px;
    margin: 0px;
    text-align: center;

    strong {
      color: var(--primary-color);
    }
  }

  .success-btn {
    width: 320px;
    height: 70px;
    font-size: var(--font-size-xxl);
  }
`;

export const SuccessWrapper = styled.div<{ isMobile?: boolean }>`
  ${props => (props.isMobile ? mobileStyle : pcStyle)}
`;
